export default function formatCurrency(moneyValue: number, minimumFractionDigits = 0, maximumFractionDigits = 2) {
  const formatter = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return formatter.format(moneyValue);
}
